<md-dropdown
  data-test="U7e5FJ8g"
  [placeholder]="cfg.placeholder"
  [valueKey]="valueKey"
  [labelKey]="cfg.labelKey"
  [labelCallback]="cfg.labelCallback"
  compareKey="uuid"
  [autocomplete]="true"
  [ngrxFormControlState]="ngrxFormControl"
  [getOptionsParams]="cfg.getOptionsParams"
  [url]="cfg.url"
  [canCreate]="false"
  [autoWidth]="true"
  (valueChange)="emitSelected()"
>
  <ng-template let-option mdTemplate="selected">
    <ng-container *ngIf="option; else emptyValue">
      <span data-test="tHpyIwDh" class="cursor-pointer">
        <span data-test="kz-yfkUq" style="text-transform: none">
          ({{ cfg.optionLabelFn(option) }})
        </span>
        <i
          data-test="P-FbMtRn"
          class="material-icons md-12 cursor-pointer"
          (click)="onClearClick()"
        >
          close
        </i>
      </span>
    </ng-container>
    <ng-template #emptyValue>
      <span data-test="sop7fr1K" class="icon icon_sm cursor-pointer">
        <svg data-test="Cf3OB6Wq" class="icon__icon-filter" width="10px" height="10px">
          <use xlink:href="#icon-filter"></use>
        </svg>
      </span>
    </ng-template>
  </ng-template>
</md-dropdown>
